// Constantes de tipos de status
export const STATUS_LOADING = 'loading';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';
export const STATUS_SDK = 'sdk';

/**
 * Cria um objeto de status de loading
 * @param {string} text - O texto a ser exibido durante o loading
 * @returns {{type: string, text: string}} Status object
 */
export const createLoadingStatus = (text) => ({
  type: STATUS_LOADING,
  text,
});

/**
 * Cria um objeto de status de sucesso
 * @param {string} text - O texto a ser exibido
 * @returns {{type: string, text: string}} Status object
 */
export const createSuccessStatus = (text) => ({
  type: STATUS_SUCCESS,
  text,
});

/**
 * Cria um objeto de status de erro
 * @param {string} text - O texto a ser exibido
 * @returns {{type: string, text: string}} Status object
 */
export const createErrorStatus = (text) => ({
  type: STATUS_ERROR,
  text,
});

/**
 * Cria um objeto de status SDK
 * @returns {{type: string}} Status object
 */
export const createSdkStatus = () => ({
  type: STATUS_SDK,
});

/**
 * Verifica se há algum status ativo (qualquer tipo)
 * @param {Object|null} status - O objeto de status
 * @returns {boolean} True se há um status ativo
 */
export const hasStatus = (status) => !!status?.type;

/**
 * Verifica se o status atual é SDK
 * @param {Object|null} status - O objeto de status
 * @returns {boolean} True se é status SDK
 */
export const isSdkStatus = (status) => status?.type === STATUS_SDK;

/**
 * Verifica se o status atual é loading
 * @param {Object|null} status - O objeto de status
 * @returns {boolean} True se está em loading
 */
export const isLoading = (status) => status?.type === STATUS_LOADING;

/**
 * Extrai o texto do status
 * @param {Object|null} status - O objeto de status
 * @returns {string} O texto do status ou string vazia
 */
export const getStatusText = (status) => status?.text || '';
